import EditIcon from "@mui/icons-material/Edit"
import { Box, IconButton } from "@mui/material"
import { useNavigate } from "react-router"
import { useCallback, useMemo } from "react"
import { getMaterialTableColumns } from "./const"
import { Table } from "@components/Table"
import { ContractDto } from "@custom-types/contract"
import { MRT_Row } from "material-react-table"

interface IContractsTableProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
  data: any[]
}

export default function ContractsTable({ data = [] }: IContractsTableProps) {
  const navigate = useNavigate()

  // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
  const handleEditClick = (id: string) => {
    const replacedId = (id as string).replaceAll("#", "%23")

    navigate(`/Administration/Contracts/${replacedId}`)
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
  const materialTableColumns = useMemo(() => getMaterialTableColumns(), [getMaterialTableColumns])

  const getRowActions = useCallback(
    ({ row }: { row: MRT_Row<ContractDto> }) => (
      <IconButton onClick={() => handleEditClick(row.original.key)}>
        <EditIcon />
      </IconButton>
    ),
    [handleEditClick],
  )

  return (
    <Box className={"contracts-table-container"}>
      <Table
        sessionStorageName={"contractsTable"}
        isExportable
        enableRowActions
        columns={materialTableColumns}
        data={data}
        renderRowActions={getRowActions}
      />
    </Box>
  )
}
